import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { DpadZoneType } from '@core/constants';

@Component({
  selector: 'caremoni-user-setting-menu-mid',
  templateUrl: './user-setting-menu-mid.component.html',
  styleUrl: './user-setting-menu-mid.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class UserSettingMenuMidComponent {

    @Input() midMenu: any;
    @Output() selectMidMenuEmit = new EventEmitter();
    DpadZoneType = DpadZoneType;
    midMenuId: number = 0;

    selectMidMenu(idx:number, id: number){
      this.selectMidMenuEmit.emit({idx: idx, id: id});
    }
}
